/**
 * 报表配置表单
 * @description 报表配置 新增、编辑
 * @author mll
 * @date 2021-6-22
 */
import React from 'react';
import PropTypes from 'prop-types';
import { component_tool, framework_tool, utils_tool } from '@/tool'
let { toChinesNum } = utils_tool;
let {
    WizComponent,
    WizCard,
    WizButton,
    WizInput,
    WizRow,
    WizCol,
    WizSelect,
    WizTag,
    Wizmessage,
    WizIcon,
    WizCollapse,
    WizTable,
    WizDivider,
    WizTooltip
} = component_tool;
let Option = WizSelect.Option
import '../../../styles/components/dataReport/reportConfigForm/index.less'

class ReportConfigForm extends WizComponent {

    constructor(props) {
        super(props);
        this.state = {
            ...props,
        }
    }


    /**
     * 基本信息
     */
    _base = () => {
        let { name, remark } = this.state
        let row = (title, key, value, placeholder, maxLength, type = 'text') => {
            let arr = {
                value, placeholder, maxLength,
                onChange: (e) => { this.setState({ [key]: e.target.value }) },

            }
            return (
                <div key={key} className='base-row'>
                    <div className='required'>*</div>
                    <div className='base-row-div'> {title}:</div>
                    {type === 'text' ? <WizInput {...arr} /> : <WizInput.TextArea {...arr} />}
                </div>
            )
        }
        return (
            <WizCard title='基础信息' icon='setting'>
                {row('报表名称', 'name', name, '请输入报表名称，最多64字', 64)}
                {row('备注', 'remark', remark, '请输入备注，最多100字', 100, 'textarea')}
            </WizCard>
        )
    }

    /**
     * 新增关联表
     */
    _add_link = () => {
        let { relationDetailList = [], baseTableList = [] } = this.state
        if (relationDetailList && relationDetailList.length) {
            let end = relationDetailList[relationDetailList.length - 1]
            if (!end || !checkEmpty(end['tableConfigId'])) {
                Wizmessage.warning('请填写完成上一张关联表')
            } else {
                this.setState({ relationDetailList: [...relationDetailList, { tableConfigId: '' }] })
            }
        } else {
            Wizmessage.warning('请填写完成上一张关联表')
        }
    }

    /**
     * 关联表
     */
    _link = () => {
        let { relationDetailList = [], baseTableList = [] } = this.state

        return (
            <WizCard title='建立关联表' icon='file-add' extra={
                <WizButton icon='plus' disabled={relationDetailList.length === baseTableList.length} onClick={this._add_link}>新增关联表</WizButton>
            }>
                <WizCollapse className={'link_collapse'} bordered={false} expandIconPosition='right' defaultActiveKey={'link_card_0'}>
                    {relationDetailList.length > 0 ?
                        relationDetailList.map((e, i) => {
                            return this._link_card(i)
                        }) : this._link_card(0)
                    }
                </WizCollapse>
            </WizCard>
        )
    }

    /**
     * 删除关联表
     */
    _link_card_delete = (i) => {
        this.state.relationFiledList = this.state.relationFiledList.map((e) => {
            return e.relationDetailOrderNum === i ? false : e
        }).filter(Boolean)
        this.state.relationDetailList.splice(i, 1)
        this.setState({ timer: new Date().getTime() })
    }

    /**
     * 关联卡片
     */
    _link_card = (index) => {
        let { relationDetailList = [], } = this.state
        let relationDetail = relationDetailList[index] || {};
        let deleteDisabled = !relationDetail.tableConfigId && relationDetail.tableConfigId !== 0 ? false : relationDetailList.map(e => e.relationTableConfigId === relationDetail.tableConfigId).filter(Boolean).length
        return (
            <WizCollapse.Panel key={'link_card_' + index} className='link_card'
                header={<WizRow>
                    <WizCol span={23}>
                        <WizIcon type='unordered-list' />
                        {`  关联表${toChinesNum(index + 1)}`}
                    </WizCol>
                    <WizCol className='link_card_delete' span={1}>{index > 0 ?
                        <WizTooltip placement="topLeft" title={'当前表被其他表关联时,不允许删除'}>
                            <WizButton disabled={deleteDisabled} onClick={() => { this._link_card_delete(index) }} type='link' size='small'><WizIcon type="delete" /></WizButton>
                        </WizTooltip>
                        : null}</WizCol>
                </WizRow>
                }
            >
                {this._link_card_select(index)}
                {
                    relationDetail && relationDetail.tableConfigId ?
                        [
                            <>{this._link_card_select_link_field(index)}</>,
                            <>{this._link_card_select_field(index)}</>,
                            <>{this._link_card_filter(index)}</>
                        ]
                        : null
                }

            </WizCollapse.Panel >

        )
    }

    /**
     * 是分割线哦
     */
    _divider = (title) => {
        return (
            <div className='link_divider'>
                <div className='link_divider_line link_divider_width' ></div>
                <div className='link_divider_font'>{title}</div>
                <div className='link_divider_line'></div>
            </div>
        )
    }

    /**
     * 选择字段
     */
    _link_card_select_field = (index) => {
        const { CheckableTag } = WizTag;
        let { baseTableList, relationFiledList = [] } = this.state
        //'relationDetailOrderNum': '0',//关联明细里面的排序序号
        //'tableFieldId': '',//字段代码ID
        let { tableConfigId } = this.state.relationDetailList[index]
        let baseTable = baseTableList.map(e => { return e.id === tableConfigId ? e : false }).filter(Boolean)[0]
        return [
            <>{this._divider('选择字段')}</>,
            <div>
                {
                    baseTable && baseTable['tableFieldList'] && baseTable['tableFieldList'].length ?
                        <div className='link_select_field_tag'>
                            {baseTable['tableFieldList'].map((field) => {
                                let { id, fieldName } = field
                                let checked = relationFiledList.map((e) => e.relationDetailOrderNum === index && e.tableFieldId === id ? e : false).filter(Boolean)[0]
                                return (
                                    <CheckableTag
                                        key={id}
                                        checked={checked}
                                        onChange={_checked => {
                                            if (checked) {
                                                this.setState({
                                                    relationFiledList: relationFiledList.map((e) => {
                                                        return e.relationDetailOrderNum === index && e.tableFieldId === id ? false : e
                                                    }).filter(Boolean)
                                                })
                                            } else {
                                                this.setState({
                                                    relationFiledList: [
                                                        ...relationFiledList,
                                                        {
                                                            'relationDetailOrderNum': index,//关联明细里面的排序序号
                                                            'tableFieldId': id,//字段代码ID
                                                            'orderNum': relationFiledList.length,//字段排序(默认从0开始)
                                                            'open': 1,//列表是否展示{0:不展示,1:展示}
                                                            'search': 1//是否作为搜索条件{0:否,1:是}
                                                        }
                                                    ]
                                                })
                                            }
                                        }}
                                    >
                                        {fieldName}
                                    </CheckableTag>
                                )
                            })}
                        </div>
                        :
                        '无对应字段'
                }
            </div>
        ]
    }

    /**
     * 过滤条件区域
     */
    _link_card_filter = (index) => {
        let { relationDetailList, baseTableList } = this.state
        let { tableConfigId, filterList = [] } = this.state.relationDetailList[index]
        let baseTable = baseTableList.map(e => { return e.id === tableConfigId ? e : false }).filter(Boolean)[0] || {}
        let tableFieldList = baseTable['tableFieldList'] || []
        return [
            <>{this._divider('过滤条件')}</>,
            <>{this._filter(index)}</>,
            <>{
                filterList.length < tableFieldList.length ?
                    <WizButton type='primary'
                        onClick={() => {
                            if (filterList && filterList.length) {
                                let { tableFieldId, operator, fieldValue } = filterList[filterList.length - 1];
                                if (checkEmpty(tableFieldId + '') && checkEmpty(operator + '') && checkEmpty(fieldValue)) {
                                    relationDetailList[index]['filterList'].push({
                                        tableFieldId: '', operator: '', fieldValue: ''
                                    })
                                    this.setState({ timer: new Date().getTime() })
                                } else {
                                    Wizmessage.warning('请先完成上一个过滤条件')
                                }
                            } else {
                                relationDetailList[index]['filterList'] = [{}]
                                this.setState({ timer: new Date().getTime() })
                            }
                        }
                        }>新增过滤条件</WizButton> : null
            }</>
        ]
    }

    /**
     * 过滤条件
     */
    _filter = (index) => {
        //     'filterList': [
        //         {
        //             'tableFieldId': '',//过滤字段代码ID
        //             'operator': '',//运算符{0:等于,1:小于,2:大于,3:小于等于,4:大于等于}
        //             'fieldValue': '1'//过滤字段值 有枚举列表存key，没有就给输入框
        //         }
        let { baseTableList } = this.state
        let { tableConfigId, filterList = [] } = this.state.relationDetailList[index]
        let baseTable = tableConfigId != null && tableConfigId != undefined ? baseTableList.map(e => { return e.id === tableConfigId ? e : false }).filter(Boolean)[0] : { tableFieldList: [] }
        let tableFieldList = baseTable && baseTable['tableFieldList'] ? baseTable['tableFieldList'] : []
        let selectFilterId = filterList.map(e => e.tableFieldId).filter(Boolean)
        return filterList.map((filter, i) => {
            let { tableFieldId, operator, fieldValue } = filter
            let { fieldExtInfo = {} } = tableFieldList.map(e => { return e.id === tableFieldId ? e : false }).filter(Boolean)[0] || {}
            let enumList = fieldExtInfo['enumList']
            let operatorList = ['等于', '小于', '大于', '小于等于', '大于等于']
            return <div className='link_filter'>
                <div className='link_filter_title' >过滤条件{toChinesNum(i + 1)}: </div>
                <WizSelect placeholder={'请选择字段'} defaultValue={tableFieldId}
                    onChange={(e) => {
                        filterList[i]['tableFieldId'] = e
                        filterList[i]['fieldValue'] = null
                        this.setState({ timer: new Date().getTime() })
                    }}>
                    {tableFieldList.map(e => {
                        return e.id !== tableFieldId && selectFilterId.indexOf(e.id) !== -1 ? null : <Option value={e.id}>{e.fieldName}</Option>
                    }).filter(Boolean)}
                </WizSelect>
                <div className='link_filter_title link_filter_next'>运算符: </div>
                <WizSelect key={tableFieldId} placeholder={'请选择运算符'} defaultValue={operator}
                    onChange={(e) => { filterList[i]['operator'] = e; this.setState({ timer: new Date().getTime() }) }}>
                    {operatorList.map((e, i) => { return <Option value={i}>{e || '未定义运算符'}</Option> })}
                </WizSelect>
                <div className='link_filter_title link_filter_next'>值: </div>
                {
                    enumList && enumList.length ?
                        <WizSelect placeholder={'请选择'} defaultValue={fieldValue}
                            onChange={(e) => { filterList[i]['fieldValue'] = e; this.setState({ timer: new Date().getTime() }) }}>
                            {enumList.map(e => <Option value={e.code}>{e.value}</Option>)}
                        </WizSelect>
                        :
                        <WizInput value={fieldValue} placeholde={'请输入'}
                            onChange={(e) => {
                                filterList[i]['fieldValue'] = e.target.value
                                this.setState({ timer: new Date().getTime() })
                            }}
                        />
                }
                <WizIcon type="minus-circle" onClick={() => {
                    this.state.relationDetailList[index]['filterList'] = filterList.map(e => { return e.tableFieldId === tableFieldId ? false : e }).filter(Boolean)
                    this.setState({ timer: new Date().getTime() })
                }} />
            </div>
        })
    }

    /**
     * 关联字段视图
     */
    _link_card_select_link_field_render = (index) => {
        let { relationDetailList, baseTableList } = this.state;
        //             'leadFiledId': '',//主表关联字段id
        //             'relationFiledId': ''//关联表字段id(id)
        let { tableConfigId, relationTableConfigId, relationFieldDetailList = [{ leadFiledId: '', relationFiledId: '' }] } = relationDetailList[index] || {};
        let table = baseTableList.map(e => { return e.id === tableConfigId ? e : false }).filter(Boolean)[0] || {}
        let relationTable = baseTableList.map(e => { return e.id === relationTableConfigId ? e : false }).filter(Boolean)[0] || {}
        let tableSelect = relationFieldDetailList.map(e => { return checkEmpty(e.leadFiledId) ? e.leadFiledId : false }).filter(Boolean) || [];
        let tableRelactionSelect = relationFieldDetailList.map(e => { return checkEmpty(e.relationFiledId) ? e.relationFiledId : false }).filter(Boolean) || [];
        let tableTableFieldList = table['tableFieldList'] ? table['tableFieldList'].map(e => { return e.fieldRelation ? e : false }).filter(Boolean) : [];
        let relationTableFieldList = relationTable['tableFieldList'] ? relationTable['tableFieldList'].map(e => { return e.fieldRelation ? e : false }).filter(Boolean) : [];
        let row = (key, value, title, i, selectList, checkList) => {
            let value_;
            if (value instanceof Number) {

            }
            return (
                <div key={key + i} className='base-row'>
                    <div className='base-row-div'> {title}:</div>
                    <WizSelect placeholder={'请选择'} defaultValue={value}
                        onChange={(_e) => {
                            let e = parseInt(_e)
                            if (!relationDetailList[index]['relationFieldDetailList']) {
                                relationDetailList[index]['relationFieldDetailList'] = [{ [key]: e }]
                            } else if (relationDetailList[index]['relationFieldDetailList'][i]) {
                                relationDetailList[index]['relationFieldDetailList'][i][key] = e
                            } else {
                                relationDetailList[index]['relationFieldDetailList'][i] = { [key]: e }
                            }
                            this.setState({ timer: new Date().getTime() })
                        }}>
                        {selectList.map(e => {
                            return <Option disabled={checkList.indexOf(e['id']) !== -1} value={e.id}>{e.fieldName}</Option>
                        })}
                    </WizSelect>
                </div>
            )
        }
        return relationFieldDetailList.map((relationFieldDetail, i) => {
            return (
                <WizRow key={i + this.state.timer} className='relation-row'>
                    <WizCol span={9}>
                        {row('leadFiledId', relationFieldDetail['leadFiledId'], '当前表字段', i, tableTableFieldList || [], tableSelect)}
                    </WizCol>
                    <WizCol className='relation-swap' span={1}>
                        <WizIcon type="swap" />
                    </WizCol>
                    <WizCol span={9}>
                        {row('relationFiledId', relationFieldDetail['relationFiledId'], '关联表字段', i, relationTableFieldList || [], tableRelactionSelect)}
                    </WizCol>
                    <WizCol span={5}>
                        {i > 0 ? <WizIcon type="minus-circle" onClick={() => { relationDetailList[index]['relationFieldDetailList'].splice(i, 1); this.setState({ timer: new Date().getTime() }) }} /> : <></>}
                        {
                            (tableSelect.length > 0 && tableSelect.length !== tableTableFieldList.length) &&
                                (tableRelactionSelect.length > 0 && tableRelactionSelect.length !== relationTableFieldList.length) &&
                                relationFieldDetailList.length < tableTableFieldList.length &&
                                relationFieldDetailList.length < relationTableFieldList.length ?
                                <WizIcon type="plus-circle" onClick={() => {
                                    if (!relationDetailList[index]['relationFieldDetailList']) {
                                        Wizmessage.warning('请选择上一项关联字段')
                                        return
                                    }
                                    relationDetailList[index]['relationFieldDetailList'].push({ leadFiledId: '', relationFiledId: '' });
                                    this.setState({ timer: new Date().getTime() })
                                }} /> : null
                        }

                    </WizCol>
                </WizRow>
            )
        })
    }

    /**
     * 关联字段
     */
    _link_card_select_link_field = (index) => {
        if (!index) { return null }
        return [
            <>{this._divider('关联字段')}</>,
            <>{this._link_card_select_link_field_render(index)}</>
        ]
    }

    /**
     * 选择表/关联表
     */
    _link_card_select = (index) => {
        let { baseTableList = [] } = this.props
        let { relationDetailList = [], relationFiledList = [] } = this.state
        let relationDetail = relationDetailList[index] || {}
        let { tableConfigId, relationTableConfigId, joinType = 0 } = relationDetail
        let relationDetailId = relationDetailList.map(e => e.tableConfigId).filter(Boolean)
        let row = (title, key, value, placeholder, checkFunc, checkDisabled) => {
            return (
                <div key={key + '_' + index + '_' + baseTableList.length} className='base-row'>
                    <div className='base-row-div'> {title}:</div>
                    <WizSelect disabled={checkDisabled} placeholder={placeholder} defaultValue={value}
                        onChange={(e) => {
                            if (relationDetailList && relationDetailList[index]) {
                                if (key === 'tableConfigId' && relationDetailList[index]['tableConfigId'] >= 0) {
                                    this.state.relationFiledList = relationFiledList.map(e => {
                                        return e['relationDetailOrderNum'] === index ? false : e
                                    }).filter(Boolean)
                                }
                                this.state.relationDetailList[index][key] = e
                                this.state.relationDetailList[index]['filterList'] = []
                                this.state.relationDetailList[index]['relationFieldDetailList'] = [{ leadFiledId: '', relationFiledId: '' }]
                            } else {
                                this.state.relationDetailList = [{ [key]: e, joinType: 0 }]
                            }
                            this.setState({ timer: new Date().getTime() })
                        }}>
                        {baseTableList.map((e, index) => {
                            return (checkFunc && checkFunc(e)) ? <Option key={key + '_' + index + '_' + e.id} value={e.id}>{e.name}</Option> : null
                        })}
                    </WizSelect>
                </div>
            )
        }

        let _join_type = (title, key, value, placeholder) => {
            let typeEmun = ['内连接', '左连接', '右连接']
            return (
                <div key={key + index} className='base-row'>
                    <div className='base-row-div'> {title}:</div>
                    <WizSelect placeholder={placeholder} defaultValue={value}
                        onChange={(e) => {
                            if (relationDetailList && relationDetailList[index]) {
                                this.state.relationDetailList[index][key] = e
                            } else {
                                this.state.relationDetailList = [{ [key]: e }]
                            }
                            this.setState({ timer: new Date().getTime() })
                        }}>
                        {typeEmun.map((e, i) => {
                            return <Option value={i}>{e}</Option>
                        })}
                    </WizSelect>
                </div>
            )
        }
        let deleteDisabled = !tableConfigId && tableConfigId !== 0 ? false : relationDetailList.map(e => e.relationTableConfigId === tableConfigId).filter(Boolean).length
        return (
            <WizRow>
                <WizCol span={9}>
                    {row('选择表', 'tableConfigId', tableConfigId, '请选择表', (e) => { return (relationDetailId.indexOf(e.id) === -1 || tableConfigId === e.id) }, deleteDisabled)}
                </WizCol>
                <WizCol span={1}></WizCol>
                {
                    index === 0 ? null :
                        [
                            <WizCol span={9}>
                                {row('关联主表', 'relationTableConfigId', relationTableConfigId, '请选择关联主表', (e) => { return (relationDetailId.indexOf(e.id) !== -1 && tableConfigId !== e.id) }, false)}
                            </WizCol>,
                            <WizCol span={5}>
                                {_join_type('关联类型', 'joinType', joinType, '请选择关联类型')}
                            </WizCol>
                        ]
                }
            </WizRow>
        )
    }



    /**
     * 配置
     */
    _config = () => {
        let { baseTableList, relationDetailList, relationFiledList = [] } = this.state
        //     'relationDetailOrderNum': '0',//关联明细里面的排序序号
        //     'tableFieldId': '',//字段代码ID
        //     'orderNum': '',//字段排序(默认从0开始)
        //     'open': '',//列表是否展示{0:不展示,1:展示}
        //     'search': ''//是否作为搜索条件{0:否,1:是}
        const columns = [
            {
                title: '字段名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '是否可展示',
                dataIndex: 'open',
                key: 'open',
                render: (text) => { return ['否', '是'][text] || '' }
            },
            {
                title: '是否可查询',
                dataIndex: 'search',
                key: 'search',
                render: (text) => { return ['否', '是'][text] || '' }
            },
            {
                title: '搜索类型',
                dataIndex: 'fieldType',
                key: 'fieldType',
                render: (text) => {
                    return ['文本', '数字', '时间', '枚举下拉框', '自定义插件'][text] || '文本'
                }
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, i) => {
                    let { open, search, tableFieldId, relationDetailOrderNum } = record
                    let onUp = (i) => {
                        let _relationFiledList = [...relationFiledList]
                        let up = _relationFiledList[i], down = _relationFiledList[i - 1]
                        up['orderNum']--
                        down['orderNum']++
                        _relationFiledList[i] = down
                        _relationFiledList[i - 1] = up
                        this.setState({ relationFiledList: _relationFiledList })
                    }
                    let onDown = (i) => {
                        let _relationFiledList = [...relationFiledList]
                        let up = _relationFiledList[i + 1], down = _relationFiledList[i]
                        up['orderNum']--
                        down['orderNum']++
                        _relationFiledList[i] = up
                        _relationFiledList[i + 1] = down
                        this.setState({ relationFiledList: _relationFiledList })
                    }
                    let change = (i, key, value) => {
                        this.state.relationFiledList[i][key] = value ? 0 : 1
                        this.setState({ timer: new Date().getTime() })
                    }
                    return <span key={relationDetailOrderNum + '_' + tableFieldId + '_' + i}>
                        {i > 0 ? [<a onClick={() => { onUp(i) }}> 上 移 </a>, <WizDivider key={i + '_' + 'up'} type="vertical" />] : null}
                        {i < (relationFiledList.length - 1) ? [<a onClick={() => { onDown(i) }}> 下 移 </a>, <WizDivider key={i + '_' + 'down'} type="vertical" />] : null}
                        <a onClick={() => { change(i, 'open', open) }}>{['设为展示', '取消展示'][open]}</a>
                        <WizDivider type="vertical" key={i + '_' + 'show'} />
                        <a onClick={() => { change(i, 'search', search) }}> {['设为查询', '取消查询'][search]}</a>
                    </span>
                },
            },
        ];
        let dataSource = relationFiledList.map((e, i) => {
            let table = baseTableList.map((table) => {
                if (!relationDetailList[e.relationDetailOrderNum] || !relationDetailList[e.relationDetailOrderNum]['tableConfigId']) {
                    return { tableFieldList: [] }
                }
                return table.id === relationDetailList[e.relationDetailOrderNum]['tableConfigId'] ? table : false
            }).filter(Boolean)[0] || { tableFieldList: [] }
            let filed = table['tableFieldList'].map(f => { return f.id === e.tableFieldId ? f : false }).filter(Boolean)[0] || {}
            let { tableFieldId, relationDetailOrderNum } = e
            return {
                key: tableFieldId + '_' + relationDetailOrderNum + '_' + i,
                ...e,
                name: filed['fieldName'] || '',
                fieldType: filed['fieldType'] || ''
            }
        })
        return (
            <WizCard title='报表配置' icon='setting'>
                <WizTable pagination={false} key={this.state.timer} columns={columns} dataSource={dataSource} />
            </WizCard>
        )
    }

    /**
     * 提交方法
     */
    submit = () => {
        let { submit } = this.props
        let { name, remark, relationDetailList, relationFiledList } = this.state
        //基础数据检查
        if (!checkEmpty(name)) { Wizmessage.warning('请填写报表名称'); return }
        if (!checkEmpty(remark)) { Wizmessage.warning('请填写备注'); return }
        //关联表检查
        if (!relationDetailList || !relationDetailList.length) { Wizmessage.warning('请选择关联表'); return }
        let error;
        let toError = (i, text) => {
            if (!error) {
                error = `关联表${toChinesNum(i + 1)}: ` + text
            }
        }
        relationDetailList.map((relationDetail, i) => {
            let { tableConfigId, relationTableConfigId, relationFieldDetailList, filterList } = relationDetail
            if (!checkEmpty(tableConfigId)) { toError(i, '请选择表') }
            if (!checkEmpty(relationTableConfigId) && i > 0) { toError(i, '请选择关联表') }
            if (i > 0) {
                if (!relationFieldDetailList || !relationFieldDetailList.length) {
                    toError(i, '请选择关联字段')
                } else {
                    relationFieldDetailList.map(({ leadFiledId, relationFiledId }) => {
                        if (!checkEmpty(leadFiledId)) { toError(i, '请选择当前表字段') }
                        if (!checkEmpty(relationFiledId)) { toError(i, '请选择关联表字段') }
                    })
                }
            }
            if (filterList && filterList.length) {
                filterList.map(({ tableFieldId, operator, fieldValue }) => {
                    if ((!checkEmpty(tableFieldId) && tableFieldId !== 0) || (!checkEmpty(operator) && operator !== 0) || (!checkEmpty(fieldValue) && fieldValue !== 0)) {
                        toError(i, '请完成过滤条件')
                    }
                })
            }

        })
        if (error) {
            Wizmessage.warning(error); return
        }
        //配置字段检查
        if (!relationFiledList || !relationFiledList.length) { Wizmessage.warning('请选择报表配置字段'); return }

        let data = { ...this.state }
        delete data['submit']
        delete data['timer']
        delete data['baseTableList']
        submit && submit({
            ...data,
            relationDetailList: relationDetailList.map((e, i) => { return { ...e, orderNum: i } }),
            relationFiledList: relationFiledList.map((e, i) => { return { ...e, orderNum: i } }),
        })
    }

    /**
     * 提交按钮
     */
    _submit = () => {
        return (
            <div className='submit-button'>
                <WizButton type='primary' onClick={this.submit}>
                    保存
                </WizButton>
            </div>
        )
    }

    render() {
        return (
            <div className='report-config-form' >
                {this._base()}
                {this._link()}
                {this._config()}
                {this._submit()}
            </div>
        )

    }
}

export default ReportConfigForm;

/**
 * 默认值
 */
ReportConfigForm.defaultProps = {
    //data 数据格式 ------- start -------
    'id': undefined,//id
    'name': undefined,//名称
    'remark': undefined,//备注
    //'state': '',//状态{0:无效,1:有效}
    'relationDetailList': [
        // {
        //     'tableConfigId': '',//选择表表名称id
        //     'relationTableConfigId': '',//选择的主关联表名称id 只有第一条是空的
        //     'joinType': '',//关联类型{0:内连接,1:左连接,2:右连接}
        //     'orderNum': '',//排序(默认第一个为主表；从0开始) 不能重复
        //     'filterList': [
        //         {
        //             'tableFieldId': '',//过滤字段代码ID
        //             'operator': '',//运算符{0:等于,1:小于,2:大于,3:小于等于,4:大于等于}
        //             'fieldValue': '1'//过滤字段值 有枚举列表存key，没有就给输入框
        //         }
        //     ],//关联表过滤字段集
        //     'relationFieldDetailList': [
        //         {
        //             'leadFiledId': '',//主表关联字段id
        //             'relationFiledId': ''//关联表字段id(id)
        //         }
        //     ]//关联字段明细集
        // }
    ],
    'relationFiledList': [
        // {
        //     'relationDetailOrderNum': '0',//关联明细里面的排序序号
        //     'tableFieldId': '',//字段代码ID
        //     'orderNum': '',//字段排序(默认从0开始)
        //     'open': '',//列表是否展示{0:不展示,1:展示}
        //     'search': ''//是否作为搜索条件{0:否,1:是}
        // }
    ],//关联表所有字段的排序集

    //data 数据格式 ------- end -------

    /**
     * 选择表列表
     */
    baseTableList: [{
        "id": "",//表ID
        "name": "",//表名称
        "tableFieldList": [
            {
                "id": "",//字段id
                "fieldName": "",//字段中文名称
                "searchName": "",//搜索名称
                "fieldType": "",//字段搜索类型{0:文本,1:数字,2:时间,3:枚举下拉框,4:自定义插件}
                "fieldRelation": "",//是否关联字段{0:否,1:是}
                "fieldExtInfo": {
                    "searchType": "",//搜索类型{0:精确搜索,1:模糊搜索}
                    "operator": "",//运算符{0:等于,1:大于,2:小于,3:小于等于,4:大于等于}
                    "format": "",//格式{0:yyyy-MM-dd HH:mm:ss,1:yyyy-MM-dd,2:HH:mm:ss}
                    "plugins": "",//自定义插件名
                    "enumList": [
                        {
                            "code": "",
                            "value": ""
                        }
                    ]//枚举集合
                }//字段扩展信息
            }
        ]//表字段
    }]

    /**
     * other 其他属性
     */
}

/**
 * props入参校验
 */
ReportConfigForm.propTypes = {
}
